import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { logOut, updateLocalStorageToken } from '../../../../../containers/resources/utils';

export const customGeneralRateList = createSlice({
  name: 'customGeneralRateList',
  initialState: {
    years: [],
    rates: [],
    yachts: [],
    days: [],
    generalRates: [],
    processing: false,
    fetching: false,
    message: "",
    error: "",
  },
  reducers: {
    initialStateGeneralRateListCustom(state, action) {
      return {
        years: [],
        rates: [],
        yachts: [],
        days: [],
        generalRates: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    requesGeneralRateListCustom(state, action) {
      return {
        years: [],
        rates: [],
        yachts: [],
        days: [],
        generalRates: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      }
    },
    fetchGeneralRateListCustomSuccess(state, action) {
      return {
        years: action.payload.years,
        rates: action.payload.rates,
        yachts: action.payload.yachts,
        days: action.payload.days,
        generalRates: action.payload.generalRates,
        processing: false,
        fetching: false,
        message: "",
        error: "",
      }
    },
    fetchGeneralRateListCustomError(state, action) {
      return {
        years: [],
        rates: [],
        yachts: [],
        days: [],
        generalRates: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.payload.message,
      }
    }
  }
})

export const fetchGeneralRateListCustom = (payload) => dispatch => {
  dispatch(requesGeneralRateListCustom());
  axios.post(`/generalRates/generalRatesList`, payload)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchGeneralRateListCustomSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchGeneralRateListCustom(payload));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchGeneralRateListCustomError(json.data.data));
      }
    })
};

export const {
  initialStateGeneralRateListCustom,
  requesGeneralRateListCustom,
  fetchGeneralRateListCustomSuccess,
  fetchGeneralRateListCustomError,
} = customGeneralRateList.actions;

export default customGeneralRateList.reducer;